/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if (window.boostSDAppConfig) {
window.boostSDAppConfig.integration =  Object.assign({
wishlists: 'plus'
}, window.boostSDAppConfig.integration || {});
}

const customize = {
   updateProductItemGrid: (componentRegistry) => {
      componentRegistry.useComponentPlugin('ProductItem', {
         name: 'Add extra information',
         enabled: true,
         apply: () => ({
            afterRender(element) {
               try {
                  // Start customization--------------------------------------------
                  let productData = element.getParams().props.product;
                  let productId = productData.id;
                  if (productData?.split_product) {
                     productId = productData.variant_id;
                  }
                  let productItem = document.querySelector('[data-product-id="' + productId + '"]');
                  let productTag = productData.tags.filter(tag => tag == "pfs:label-パーク来場者限定");

                  if (productItem) {
                     /* use pure js here */
                     if (productTag.length > 0) {
                       const customTags = productItem.querySelectorAll('.boost-sd__product-label--customLabelByTag');
                       for (let i = 0; i < customTags.length; i++) {
                         let customTag = customTags[i];
                         let text = customTag.querySelector('.boost-sd__product-label-text').textContent;
                         if (text == 'パーク来場者限定') {
                           customTag.classList.add("customPfsTag");
                           productItem.querySelector('.boost-sd__product-image-row--bottom').appendChild(customTag);
                         }
                       }
                     }

                    // Hide label
                    let productLabelEls = document.querySelectorAll('.boost-sd__product-label-text');
                    productLabelEls.forEach(function(el){
                      if(el.innerText == '来場せずに購入できる'){
                        el.parentNode.classList.add('boost-sd-label-hide');
                      }
                    });
                  }
                  // End-------------------------------------------------------------
               } catch (e) {
                  console.warn(e);
               }
            }
         }),
      });
   }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItemGrid]);